import React, { useEffect, useRef } from 'react';
import './Game.css';
import commandCardsWebp from '../../../assets/images/game_comand_cards.webp';
import commandCardsPng from '../../../assets/images/game_comand_cards.png';
import traitCardsWebp from '../../../assets/images/game_trait_cards.webp';
import traitCardsPng from '../../../assets/images/game_trait_cards.png';
import gameVirusWebp from '../../../assets/images/game_virus.webp';
import gameVirusPng from '../../../assets/images/game_virus.png';
import cardCombine from '../../../assets/images/game_cardcombine.webm';

const Game = () => {
  const titleContainerRef = useRef(null);
  const squareRef = useRef(null);
  const gameContainerRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting && titleContainerRef.current) {
        titleContainerRef.current.classList.add('active');
      }
    }, { threshold: 0.99 });
    if (titleContainerRef.current) observer.observe(titleContainerRef.current);
    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    const squareObserver = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        document.querySelector('.blue-line-vertical-game')?.classList.add('active');
        document.querySelector('.blue-line-horizontal-game')?.classList.add('active');
      }
    }, { threshold: 0.5 });

    if (squareRef.current) squareObserver.observe(squareRef.current);
    return () => squareObserver.disconnect();
  }, []);

  useEffect(() => {
    const gameContainerObserver = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting && gameContainerRef.current) {
        gameContainerRef.current.classList.add('visible');
      }
    }, { threshold: 0.2 });

    if (gameContainerRef.current) gameContainerObserver.observe(gameContainerRef.current);
    return () => gameContainerObserver.disconnect();
  }, []);

  return (
    <div className="game-container" ref={gameContainerRef}>
              <div className="blue-line-vertical-game"></div>
              <div className="blue-line-horizontal-game"></div>
      <div className="title-container" ref={titleContainerRef}>
        <h2 className="fns-title-font">Mastery over your deck.<span className="cursor">|</span></h2>
        
        <div ref={squareRef} className="blue-square-game"></div>
        <div className="digital-lines-game"></div>
      </div>
      <section className="game-section">

        <h3 className="fns-title-font">The Dual Deck System</h3>
        <p>
        For each journey into the city, you’ll choose a Drone and a Pilot, each with their own types of cards. These cards are used both for combat, but also dictate how you can resolve problems you’ll encounter deep within the technological ruins.
        </p>

        <div className="deck-system">
          <div className="deck-type">
            <h3 className="fns-title-font">Command Cards</h3>
            <div className="deck-image">
              <picture>
                <source srcSet={commandCardsWebp} type="image/webp" />
                <img src={commandCardsPng} alt="Command Cards Preview" />
              </picture>
            </div>
            <p>
              Drones come with unique Command Cards - their core functions for combat and navigation.
            </p>
          </div>

          <div className="deck-type">
            <h3 className="fns-title-font">Trait Cards</h3>
            <div className="deck-image">
              <picture>
                <source srcSet={traitCardsWebp} type="image/webp" />
                <img src={traitCardsPng} alt="Trait Cards Preview" />
              </picture>
            </div>
            <p>
              Pilots' personalities emerge through Trait Cards, influencing both combat and 
              interactions with the city's inhabitants.
            </p>
          </div>
        </div>

        <div className="customization-list">
          <div className="customization-item">
            <h3 className="fns-title-font">Mods and Viruses</h3>
            <div className="deck-image">
              <picture>
                <source srcSet={gameVirusWebp} type="image/webp" />
                <img src={gameVirusPng} alt="Virus Mods Preview" />
              </picture>
            </div>
            <p>Transform familiar cards with powerful new effects.</p>
          </div>

          <div className="customization-item">
            <h3 className="fns-title-font">Card Fusion</h3>
            <div className="deck-image">
              <video autoPlay loop muted playsInline>
                <source src={cardCombine} type="video/webm" />
              </video>
            </div>
            <p>Combine duplicate cards to create stronger, more efficient versions.</p>
          </div>
        </div>
      </section>
      </div>
  );
};

export default Game;
